interface AppState {
  appOutOfDate: boolean
}

const state: AppState = {
  appOutOfDate: false,
}

const getters = {
  appOutOfDate: () => state.appOutOfDate,
  appVersion: () => process.env.APP_VERSION,
}

const actions = {
  setAppOutOfDate({ commit }, { appOutOfDate }: { appOutOfDate: boolean }) {
    commit('appOutOfDate', appOutOfDate)
  },
}

const mutations = {
  appOutOfDate(state: AppState, appOutOfDate: boolean) {
    state.appOutOfDate = appOutOfDate
  },
}

export const app = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
